import styled from "@emotion/styled";

export const Image = styled("img")`
    height: 100%;
    width: 100%;
    user-select: none;
    opacity: 0;
`;
